import Box from '@mui/material/Box';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Box": Box, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Radio": Radio, "@mui/material/FormControl": FormControl, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/FormLabel": FormLabel, "@mui/material/styles": { ThemeProvider, createTheme, useColorScheme } } } });
export default ClientProvider;
